import React from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
    <p className="App-header">The Omega Horns</p>
      <header className="App-body">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Something's coming...
        </p>
      </header>
      <div>Icons made by <a href="https://www.flaticon.com/authors/freepik" title="Freepik">Freepik</a> from <a href="https://www.flaticon.com/"                 title="Flaticon">www.flaticon.com</a> is licensed by <a href="http://creativecommons.org/licenses/by/3.0/"                 title="Creative Commons BY 3.0" target="_blank">CC 3.0 BY</a></div>
    </div>
  );
}

export default App;
